<template>
  <div class="order">
    <div class="order_nav">
      <form action="/">
        <van-search
          v-model="value"
          show-action
          placeholder="请输入商品id"
          @search="onSearch"
          @cancel="onCancel"
        />
      </form>
    </div>
    <div class="all">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        v-if="list.length != 0"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="已经是全部内容了"
          @load="onLoad"
        >
          <van-cell class="lists" v-for="(item, index) in list" :key="index">
            <van-row v-if="item.type == 1">
              <van-col span="24" class="title">
                {{ item.goods_name }}
              </van-col>
              <van-col span="24">订单编号：{{ item.ordersn }}</van-col>
              <van-col span="24">完成时间：{{ item.created_at }}</van-col>
              <van-col span="24">
                商品ID：{{ item.goods_id }}
                <span class="commission">
                  <span class="balance">
                    <span>+</span>{{ item.balance }}
                  </span>
                </span>
              </van-col>
            </van-row>
            <van-row v-if="item.type == 3">
              <van-col span="24" class="title">
                {{ item.balance > 0 ? "平台增加" : "平台扣减" }}
              </van-col>
              <van-col span="24">原因：{{ item.reason }}</van-col>
              <van-col span="24">操作时间：{{ item.created_at }}</van-col>
              <van-col span="24">
                操作ID：{{ item.id }}
                <span class="commission">
                  <span class="word">金额：</span>
                  <span class="balance">
                    <span v-show="item.balance > 0">+</span
                    ><span v-show="item.balance < 0">-</span
                    >{{ item.balance > 0 ? item.balance : -item.balance }}
                  </span>
                </span>
              </van-col>
            </van-row>
          </van-cell>
        </van-list>
      </van-pull-refresh>
      <van-row class="empty" v-if="list.length == 0 && !hasList && gooodsid">
        <van-col class="emptyMsg" span="24">
          <img src="../../../assets/purchaseSupplier/common/no_info.png" />
          <p class="tip">无内容</p>
        </van-col>
      </van-row>
      <div class="loading" v-if="list.length <= 0 && hasList && gooodsid">
        <img src="../../../assets/accountAgent/common/loading.gif" />
      </div>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      righticon: require("@/assets/purchaseSupplier/common/search.png"),
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      hasList: true,
      value: "",
      gooodsid: "",
    };
  },
  created() {
    // this.getInfo();
  },
  watch: {
    gooodsid() {
      this.page = 1;
      this.list = [];
      this.getInfo();
    },
  },
  methods: {
    onCancel() {
      this.$router.go(-1);
    },
    onSearch(val) {
      this.gooodsid = val;
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
    },
    getInfo() {
      if (!this.gooodsid) {
        return;
      }
      this.$api
        .post("/member-relation/member/three/year/supplier/amount-details", {
          page: this.page,
          supplier_id: this.$route.query.id,
          id: this.gooodsid,
        })
        .then((res) => {
          this.allList = res.total;
          if (res.total <= 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.order {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .order_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;

    .van-search {
      height: 4.4rem;
      line-height: 4.4rem;
      padding: 0 0.8rem 1.4rem 1.6rem;
      box-sizing: border-box;

      .van-search__content {
        padding-left: 2rem;
        line-height: 3rem;
        font-size: 1.4rem;

        .van-cell {
          height: 3rem;
          border-radius: 1.5rem;
        }
      }
    }
  }

  .all {
    padding-top: 8.8rem;
    box-sizing: border-box;
    height: 100%;

    .van-pull-refresh {
      height: 100%;
      padding: 1.2rem 1.6rem 0;
      box-sizing: border-box;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;

      .lists {
        min-height: 13.1rem;
        border-radius: 0.8rem;
        background: #fff;
        margin-bottom: 1.2rem;
        padding: 2rem 1.6rem;
        box-sizing: border-box;

        .van-col {
          color: #999;
          font-size: 1.2rem;
          line-height: 2.5rem;

          .commission {
            float: right;
            color: #333;
            font-size: 1.2rem;
            height: 2.4rem;
            line-height: 2.4rem;

            .word {
              height: 2.4rem;
              line-height: 2.4rem;
              display: inline-block;
              float: left;
            }

            .balance {
              color: #ff4747;
              font-size: 2rem;
              font-weight: 700;

              span {
                margin-right: 1rem;
              }
            }
          }
        }

        .title {
          color: #333;
          font-size: 1.4rem;
          text-align: left;
          line-height: 2rem;
          margin-bottom: 0.4rem;
        }
      }
    }

    .empty {
      padding-top: 10rem;

      .emptyMsg {
        text-align: center;

        img {
          width: 16rem;
          display: inline-block;
        }

        .tip {
          color: #cccccc;
          font-size: 1.4rem;
          margin-top: 1.7rem;
          height: 2rem;
          line-height: 2rem;
        }
      }
    }

    .loading {
      width: 100%;
      /*padding-top: 100px;*/
      text-align: center;

      img {
        width: 35%;
        margin-top: 50%;
      }
    }
  }
}
</style>




